import { PropsWithChildren, useEffect } from 'react';
import { DefaultTheme, FlattenInterpolation, ThemeProps } from 'styled-components';

import Close from '~components/Icon/Close';
import PortalContainer from '~components/PortalContainer';

import * as S from './style';

export interface ModalBaseProps {
  isOpen: boolean | undefined;
  handleClose: () => void;
  inlineCss?: FlattenInterpolation<ThemeProps<DefaultTheme>>;
  maskClosable?: boolean;
  hasCloseButton?: boolean;
  verticalAlign?: 'center';
}

export default function ModalBase({
  children,
  inlineCss,
  isOpen,
  verticalAlign,
  handleClose,
  maskClosable,
  hasCloseButton,
}: PropsWithChildren<ModalBaseProps>) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (isOpen && (event.key === 'Escape' || event.keyCode === 27)) {
        console.log('hi?');
        event.preventDefault();
        handleClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown, true);

    return () => {
      window.removeEventListener('keydown', handleKeyDown, true);
    };
  }, [isOpen]);

  const handleClickBackground = () => {
    if (maskClosable) {
      handleClose();
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <PortalContainer className='modalContainer'>
      <S.ModalGlobalStyle />
      <S.Wrapper role='dialog'>
        <S.Background onClick={handleClickBackground} />
        <S.ModalContent inlineCss={inlineCss} verticalAlign={verticalAlign}>
          {hasCloseButton && (
            <S.ButtonClose onClick={() => handleClose()}>
              <Close />
            </S.ButtonClose>
          )}
          {children}
        </S.ModalContent>
      </S.Wrapper>
    </PortalContainer>
  );
}
